<template>
    <div>
        <div
            v-for="(font, index) in fonts"
            :key="index"
            @click="setTextVariable(font.family)"
            class="fontOptions__item"
        >
            {{ font.family }}
        </div> 
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        methods: {
            setTextVariable(variable) {
                let payload = {
                    variableName: 'family',
                    value: variable
                }
                this.$store.dispatch('SET_TEXT_VARIABLE', payload)
            }
        },
        computed: {
            ...mapState([
                'fonts',
            ]),
            ...mapGetters([
                'getActiveElement'
            ])
        }
    }
</script>

<style lang="scss" scoped>
    .fontOptions__item {
        cursor: pointer;
        margin: 5px 0;
        word-break: break-all;
    }
</style>